import React from 'react';
import { useSelector } from 'react-redux';
import NgoProfile from './NgoProfile';
import CompanyProfile from './CompanyProfile';

const Profile = () => {
  const { partnerType } = useSelector((state) => state.partner);

  // Conditionally render based on partner type
  if (partnerType === 'ngo') {
    return <NgoProfile />;
  } else if (partnerType === 'company') {
    return <CompanyProfile />;
  }

  // Fallback for unknown partner type or loading state
  return (
    <div className='w-full p-6 flex items-center justify-center min-h-screen'>
      <div className='text-center'>
        <div className='text-gray-600 mb-4'>Loading profile...</div>
        <div className='text-sm text-gray-500'>
          Partner Type: {partnerType || 'Not detected'}
        </div>
      </div>
    </div>
  );
};

export default Profile;
